// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Translations
import {
  PROOF_INCOME_LANDING_DESCRIPTION_METHOD_OPENBANKING,
  PROOF_INCOME_LANDING_DESCRIPTION_METHOD_TGSS,
  PROOF_INCOME_LANDING_TITLE_METHOD_OPENBANKING,
  PROOF_INCOME_LANDING_TITLE_METHOD_TGSS,
} from '../translations/proof-income-landing.configuration.translations';

const PROOF_INCOME_LANDING_FEATURES_CONFIGURATION = {
  [ProofIncomeMethodsEnumeration.OPENBANKING]: {
    description: PROOF_INCOME_LANDING_DESCRIPTION_METHOD_OPENBANKING,
    icon: 'icon_categories_organizations-and-ongs',
    title: PROOF_INCOME_LANDING_TITLE_METHOD_OPENBANKING,
  },
  [ProofIncomeMethodsEnumeration.TGSS]: {
    description: PROOF_INCOME_LANDING_DESCRIPTION_METHOD_TGSS,
    icon: 'icon_documents_transactions',
    title: PROOF_INCOME_LANDING_TITLE_METHOD_TGSS,
  },
};

export { PROOF_INCOME_LANDING_FEATURES_CONFIGURATION };
